export default "__VITE_ASSET__BoERQHGK__"